import { getNotifications, markNotificationsDeleted, markNotificationsRead } from '@/redux/modules/notification';
import { trackDesktopNotificationsView } from '@/redux/modules/analytics';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';

export const useNotificationDataProps = () => {
    const dispatch = useAppDispatch();
    const notifications = useAppSelector(getNotifications);

    const markRead = useCallback((ids: number[]) => dispatch(markNotificationsRead(ids)), [dispatch]);
    const markDeleted = useCallback((ids: number[]) => dispatch(markNotificationsDeleted(ids)), [dispatch]);
    const notificationTrackView = useCallback(() => dispatch(trackDesktopNotificationsView()), [dispatch]);

    return {
        count: notifications.length,
        markDeleted,
        markRead,
        notifications,
        trackView: notificationTrackView,
    };
};
